// @flow
import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

function TaxAlert(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Base marginBottom="base" padding="small" backgroundColor="surface">
      <Base tagName="p" margin="none">
        {__(
          'When you purchase the delivery of a service for someone else (the customer who receives the service), you must ensure that the applicable VAT rules are followed. This means that the person who receives the service constitutes the beneficial owner of the service subject to VAT in the member state in which they reside.',
        )}
      </Base>
    </Base>
  );
}

export default TaxAlert;
